const types = {
  CLEAR_CURRENT: 'PRODUCTS_CLEAR_CURRENT',
  GET_REQUEST: 'PRODUCTS_GET_REQUEST',
  GET_SUCCESS: 'PRODUCTS_GET_SUCCESS',
  GET_FAILURE: 'PRODUCTS_GET_FAILURE',

  SAVE_REQUEST: 'PRODUCTS_SAVER_REQUEST',
  SAVE_SUCCESS: 'PRODUCTS_SAVE_SUCCESS',
  SAVE_FAILURE: 'PRODUCTS_SAVE_FAILURE',

  GETALL_REQUEST: 'PRODUCTS_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRODUCTS_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRODUCTS_GETALL_FAILURE',

  DELETE_REQUEST: 'PRODUCTS_DELETE_REQUEST',
  DELETE_SUCCESS: 'PRODUCTS_DELETE_SUCCESS',
  DELETE_FAILURE: 'PRODUCTS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'PRODUCTS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PRODUCTS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PRODUCTS_UPDATE_FAILURE'    

};

export default types;